/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { PremiumCalculatorMessage } from '../../../services/messages';
import {
  FormatMoney,
  getAllInfoByISO,
} from '@vlinder-web/pricing-powerpuff-module-react';
import insuranceCalcConfig from '../../../config/insurance-calculator.config.json';

export const triggerTotalPremium = (lifeCycle: any) => {
  const message = lifeCycle?.fsm?.message as PremiumCalculatorMessage;
  // @ts-ignore
  const countryFound = insuranceCalcConfig[message.country];
  if (!countryFound) {
    throw Error(`unsupported country ${message.country} for this product`);
  }
  const format = new FormatMoney({ decimals: 2 });
  const result: any = {
    country: message.country,
    coverage: {
      raw: message.coverage,
      formatted: format.from(message.coverage, {
        symbol: getAllInfoByISO(message.country)?.symbol,
      }),
    },
    policyOptions: [...(countryFound.policyOptions || [])],
  };
  if (result) {
    result?.policyOptions?.forEach((opt: any, opti: number) => {
      const rol = opt.rolPct;
      let _premium = message.coverage * (rol / 100);
      if (message?.platformCharge?.raw) {
        _premium += message.platformCharge.raw;
      }
      if (message?.insuranceProviderCharge?.raw) {
        _premium += message.insuranceProviderCharge.raw;
      }
      opt.premium = {
        raw: _premium,
        formatted: format.from(_premium, {
          symbol: getAllInfoByISO(message.country)?.symbol,
        }),
      };
      opt?.triggeringParams?.forEach((tp: any, tpi: number) => {
        // const tpCoverage = message.coverage * (tp.coveragePct / 100);
        tp.coverage = {
          raw: tp.coveragePct,
          // formatted: format.from(tpCoverage, {
          //   symbol: getAllInfoByISO(message.country)?.symbol,
          // }),
          formatted: tp.coveragePct,
        };
      });
    });
  }
  message.totalPremium = result;
  return true;
};
